import React, { FC } from 'react';
import { Layout } from 'antd';
import { IProps } from 'src/types/layout.types';
import styles from './bare.module.less';
import PropCapHeader from '../header/header';
const { Content, Header } = Layout;

const BareLayout: FC<IProps> = ({ children }: IProps) => {
	return (
		<Layout className={`${styles.antLayoutBare} ${styles.antLayoutBareWithBackgroundImg}`}>
			<Header className={styles.antLayoutHeaderBare}>
				<PropCapHeader />
			</Header>
			<Content className={styles.antLayoutContentBare}>{children}</Content>
		</Layout>
	);
};
export default BareLayout;
